/* import __COLOCATED_TEMPLATE__ from './locale-input.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();